import type { UnitOption } from '@/api/cockpit';

export function resolveSelectedUnitDisplay(
  options: readonly UnitOption[],
  symbol: string,
): string {
  if (!symbol) return '';
  const option = options.find((candidate) => candidate.symbol === symbol);
  return option?.display ?? symbol;
}
